"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateDisplayedProduct = exports.setShowPlans = exports.setShowDevices = exports.setDisplayedProducts = exports.setComparisonSpecs = exports.setComparableProductList = exports.UPDATE_DISPLAYED_PRODUCTS = exports.SET_SHOW_PLANS = exports.SET_SHOW_DEVICES = exports.SET_DISPLAYED_PRODUCTS = exports.SET_COMPARISON_SPECS = exports.SET_COMPARABLE_PRODUCT_LIST = void 0;
var SET_COMPARABLE_PRODUCT_LIST = 'SET_COMPARABLE_PRODUCT_LIST';
exports.SET_COMPARABLE_PRODUCT_LIST = SET_COMPARABLE_PRODUCT_LIST;
var SET_DISPLAYED_PRODUCTS = 'SET_DISPLAYED_PRODUCTS';
exports.SET_DISPLAYED_PRODUCTS = SET_DISPLAYED_PRODUCTS;
var SET_COMPARISON_SPECS = 'SET_COMPARISON_SPECS';
exports.SET_COMPARISON_SPECS = SET_COMPARISON_SPECS;
var SET_SHOW_DEVICES = 'SET_SHOW_DEVICES';
exports.SET_SHOW_DEVICES = SET_SHOW_DEVICES;
var SET_SHOW_PLANS = 'SET_SHOW_PLANS';
exports.SET_SHOW_PLANS = SET_SHOW_PLANS;
var UPDATE_DISPLAYED_PRODUCTS = 'UPDATE_DISPLAYED_PRODUCTS';
exports.UPDATE_DISPLAYED_PRODUCTS = UPDATE_DISPLAYED_PRODUCTS;
var setComparableProductList = function setComparableProductList(productList) {
  return {
    type: SET_COMPARABLE_PRODUCT_LIST,
    payload: {
      productList: productList
    }
  };
};
exports.setComparableProductList = setComparableProductList;
var setDisplayedProducts = function setDisplayedProducts(products) {
  return {
    type: SET_DISPLAYED_PRODUCTS,
    payload: {
      products: products
    }
  };
};
exports.setDisplayedProducts = setDisplayedProducts;
var setComparisonSpecs = function setComparisonSpecs(specs) {
  return {
    type: SET_COMPARISON_SPECS,
    payload: {
      specs: specs
    }
  };
};
exports.setComparisonSpecs = setComparisonSpecs;
var setShowDevices = function setShowDevices(showDevices) {
  return {
    type: SET_SHOW_DEVICES,
    payload: {
      showDevices: showDevices
    }
  };
};
exports.setShowDevices = setShowDevices;
var setShowPlans = function setShowPlans(showPlans) {
  return {
    type: SET_SHOW_PLANS,
    payload: {
      showPlans: showPlans
    }
  };
};
exports.setShowPlans = setShowPlans;
var updateDisplayedProduct = function updateDisplayedProduct(previousId, newId) {
  return {
    type: UPDATE_DISPLAYED_PRODUCTS,
    payload: {
      previousId: previousId,
      newId: newId
    }
  };
};
exports.updateDisplayedProduct = updateDisplayedProduct;